// extracted by mini-css-extract-plugin
export default {"no-loads-advice":"LoadsTable_no-loads-advice__uJUUi","loads-table":"LoadsTable_loads-table__cpys7","loads-table-col-name":"LoadsTable_loads-table-col-name__GZ7dG"};